<template>
  <div>
    <router-view v-if="isAccessProjectCreate() || !isEmptyProjects" />
    <EmptyProject v-if="!isAccessProjectCreate() && isEmptyProjects" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EmptyProject from '@/project/EmptyProject.vue';

export default {
  components: {
    EmptyProject,
  },
  computed: {
    ...mapGetters(['projectIds', 'getProjectById', 'isEmptyProjects']),
    projectId() {
      return this.$route.params.projectId;
    },
    teamName() {
      return this.$route.params.teamName;
    },
  },
  data() {
    return {
      projects: null,
    };
  },
  mounted() {
  },
  methods: {
    isAccessProjectCreate() {
      return this.$route.name === 'projectCreate';
    },
  },
};
</script>
